export const getPublicSiteConfigs = (build) => build.query({
    query: (url) => {
        return {
            url: url,
            method: 'get',
        };
    },
});
